import { HTMLAttributes } from 'react'

import Container from '@/components/base/container'
import Form from '@/components/base/form'
import Grid from '@/components/base/grid'
import Section from '@/components/base/section'
import Typography from '@/components/base/typography'

import { cn } from '@/lib/utils'

export type FormSectionProps = HTMLAttributes<HTMLDivElement> &
  Partial<{
    theme: 'light' | 'dark'
    pretitle: string
    title: string
    form: any
  }>

const FormSection = ({ theme, pretitle, title, form, ...props }: FormSectionProps) => {
  return (
    <Section
      className={cn('text-dark dark:text-white', {
        dark: theme === 'dark'
      })}
      {...props}
    >
      <Container>
        <Grid className="gap-y-[2.5rem] border-t border-dark pt-[4rem] dark:border-white/80">
          <div className={cn('col-span-2 md:col-span-2 lg:col-span-3')}>
            <div className="grid gap-y-[2rem]">
              {pretitle ? (
                <Typography variant="upper-small" component="h3" className="font-bold uppercase">
                  {pretitle}
                </Typography>
              ) : null}

              {title ? (
                <Typography variant="main-title-default" component="h2">
                  {title}
                </Typography>
              ) : null}
            </div>
          </div>

          <div className="col-span-2 md:col-span-4 lg:col-span-9">
            <Form
              form_id={form?.id}
              fields={form?.fields}
              submit={form?.button?.text}
              data-motion-form
            />
          </div>
        </Grid>
      </Container>
    </Section>
  )
}

export default FormSection
